import React, { useEffect, useRef, useState } from 'react';
import TopUtilityBar from './TopUtilityBar';
import Navbar from './Navbar';
import MobileMenuDrawer from './MobileMenuDrawer';
import Footer from './Footer';

export default function PublicLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [headerHidden, setHeaderHidden] = useState(false);
  const lastScrollYRef = useRef(0);
  const menuButtonRef = useRef(null);

  const closeMobile = (restoreFocus = false) => {
    setMobileOpen(false);
    if (restoreFocus) {
      window.setTimeout(() => menuButtonRef.current?.focus(), 0);
    }
  };

  useEffect(() => {
    if (!mobileOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') closeMobile(true);
    };
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [mobileOpen]);

  useEffect(() => {
    lastScrollYRef.current = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const lastScrollY = lastScrollYRef.current;
      const delta = currentScrollY - lastScrollY;

      if (Math.abs(delta) < 8) {
        return;
      }

      if (mobileOpen) {
        setHeaderHidden(false);
      } else if (currentScrollY <= 120) {
        setHeaderHidden(false);
      } else if (delta > 0) {
        setHeaderHidden(true);
      } else {
        setHeaderHidden(false);
      }

      lastScrollYRef.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [mobileOpen]);

  return (
    <div className="public-site">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <TopUtilityBar />
      <Navbar
        onToggleMobile={() => {
          if (mobileOpen) closeMobile(false);
          else setMobileOpen(true);
        }}
        mobileOpen={mobileOpen}
        hidden={headerHidden}
        menuButtonRef={menuButtonRef}
      />
      <MobileMenuDrawer open={mobileOpen} onClose={closeMobile} />
      <main className="ps-main" id="main-content" tabIndex="-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}
